var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-player"},[_c('video',{ref:"video",staticClass:"video",attrs:{"controls":"controls","controlslist":"nodownload","id":"video"}}),(_vm.showMask)?_c('div',{staticClass:"mask"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }